import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { ITEM_MODE_NO } from '../../Constants';
import { ModelLoadSystem } from '../../../view3d/webcad/WebCad3dModelLoadSystem';

/**
 * WebCADの表示設定ダイアログ
 * グリッド色、背景色など
 */
export default class CustomizeHabakiDialog extends Dialog {
  /**
   * コンストラクタ
   */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'customizeHabakiDialog';
    // タイトル
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en':
        title = 'Settings';
        break;
      default:
        title = '設定';
        break;
    }
    let contents = '<div>\n';
    contents += '<span class="jp">巾木幅：</span><span class="en">Habaki Width:</span>\n';
    contents += '<input id="habakiHeight" width="200px" type="number" min="0" max="200"/> mm\n';
    contents += '</div>';
    contents += '<div style="padding-top:8px"><span class="jp" style="font-size:12px">※全ての部屋の巾木高さを変更します</span><span class="en" style="font-size:12px">*All rooms will be updated</span></div>';

    let footer = '<button id="btnDoneCustomizeHabaki"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);

    // イベント設定
    // OKButtonクリックをトリガー
    const btn = document.querySelector('#btnDoneCustomizeHabaki');
    btn.addEventListener('click', this.btnEventHandler);

    // 巾木高さ
    const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
    (<HTMLInputElement>document.getElementById('habakiHeight')).value = jsonData.height.habaki_height.toString(10);

    // バリエーション
    const habakiInput: HTMLInputElement = document.getElementById('habakiHeight') as HTMLInputElement;
    habakiInput.addEventListener('keyup', (_) => {
      const val = parseInt(habakiInput.value);
      const max = parseInt(habakiInput.max);
      if (max < val) habakiInput.value = max.toString(10);
    });

    // closeButtonクリックをトリガー
    document.getElementById('btnClose')
      .addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
  }

  /**
   * OKボタンがクリックされた
   * グリッド色、背景色、squareUnitマージグリッドを処理します
   * @return void
   * @param e => mouse event
   */
  btnEventHandler = (e: any) => {
    e.preventDefault();

    // 巾木高さ
    const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
    jsonData.height.habaki_height = parseInt((<HTMLInputElement>document.getElementById('habakiHeight')).value);
    marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);

    // 全ての部屋の巾木を変更する
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    itemList.forEach((room) => {
      room.itemInfo.habaki_height = jsonData.height.habaki_height;
    });

    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();

    // 見積の更新
    marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

    // 3Dモードの場合、3D表示を更新
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();
      marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;

      const json = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

      new ModelLoadSystem().request3D();
    }
  };
}
